const buildUrl = ((baseUrl, params) => {
  const url = new URL(baseUrl);
  const urlParams = new URLSearchParams(url.search);

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      urlParams.set(key, value);
    });
  }

  url.search = urlParams.toString();

  return url.href; // Return a string of the whole URL
});

export const compareUrlsWithUnorderedQueryParams = (a, b) => {
  const urlA = new URL(a);
  const urlB = new URL(b);

  const baseA = urlA.protocol + urlA.hostname + urlA.pathname;
  const baseB = urlB.protocol + urlB.hostname + urlB.pathname;
  const baseMatches = baseA === baseB;
  if (!baseMatches) {
    return false;
  }

  urlA.searchParams.sort();
  urlB.searchParams.sort();

  return urlA.searchParams.toString() === urlB.searchParams.toString();
};

export default buildUrl;
